module.exports = __webpack_public_path__ + "img/bg-mision-2-30.6f91cd40.jpg";